var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26415 0H19.4717C20.7222 0 21.7358 1.16795 21.7358 2.6087V9.3913C21.7358 10.832 20.7222 12 19.4717 12H2.26415C1.01369 12 0 10.832 0 9.3913V2.6087C0 1.16795 1.01369 0 2.26415 0ZM2.26425 1.04348C1.51398 1.04348 0.905762 1.74425 0.905762 2.6087V9.3913C0.905762 10.2557 1.51398 10.9565 2.26425 10.9565H19.4718C20.2221 10.9565 20.8303 10.2557 20.8303 9.3913V2.6087C20.8303 1.74425 20.2221 1.04348 19.4718 1.04348H2.26425Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6416 3.4433C23.448 3.91827 24.0001 4.88484 24.0001 5.99997C24.0001 7.11511 23.448 8.08168 22.6416 8.55664V3.4433Z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71718 2.08698H19.0191C19.5193 2.08698 19.9247 2.55416 19.9247 3.13045V8.86958C19.9247 9.44588 19.5193 9.91306 19.0191 9.91306H2.71718C2.217 9.91306 1.81152 9.44588 1.81152 8.86958V3.13045C1.81152 2.55416 2.217 2.08698 2.71718 2.08698Z",
    fill: "#010101"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.aa33a34e119c2fab2fec6662e5d28f98.svg";
export { ForwardRef as ReactComponent };